var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Aligned",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inprogress",
    transform: "translate(3904 2010)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13020",
    "data-name": "Path 13020",
    d: "M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0",
    transform: "translate(-3904 -2010)",
    fill: "#ffa76c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13021",
    "data-name": "Path 13021",
    d: "M8.4,2A6.4,6.4,0,1,1,2,8.4,6.407,6.407,0,0,1,8.4,2",
    transform: "translate(-3904.398 -2010.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13022",
    "data-name": "Path 13022",
    d: "M9.151,4V8.8l-3.4,3.4A4.8,4.8,0,1,0,9.151,4",
    transform: "translate(-3905.152 -2010.801)",
    fill: "#ffa76c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/In-Progress.3819dda0a9e196527c23273676bb90d9.svg";
export { ForwardRef as ReactComponent };